// Generated by Melange

import * as Buhta_cabinet__Button from "../html/Button.js";
import * as Buhta_cabinet__EventHandlers from "../../util/EventHandlers.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(sendDataToFilterOpt) {
  const sendDataToFilter = sendDataToFilterOpt !== undefined ? sendDataToFilterOpt : (function (state) {
        
      });
  return function (sendPeriodToFilterOpt) {
    const sendPeriodToFilter = sendPeriodToFilterOpt !== undefined ? sendPeriodToFilterOpt : (function (state) {
          
        });
    return function (classNameOpt) {
      const className = classNameOpt !== undefined ? classNameOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const isDropdownShown = match[0];
      const match$1 = React.useState(function () {
            return false;
          });
      const setStatusFilter = match$1[1];
      const statusFilter = match$1[0];
      const match$2 = React.useState(function () {
            return 0;
          });
      const setFilterCount = match$2[1];
      const filterCount = match$2[0];
      const match$3 = React.useState(function () {
            return false;
          });
      const setPeriodFilter = match$3[1];
      const periodFilter = match$3[0];
      const match$4 = React.useState(function () {
            return 0;
          });
      const setPeriodCount = match$4[1];
      const periodCount = match$4[0];
      const match$5 = React.useState(function () {
            return "";
          });
      const setSelectedOption = match$5[1];
      const selectedOption = match$5[0];
      const match$6 = React.useState(function () {
            return /* [] */0;
          });
      const setSelectedState = match$6[1];
      const selectedState = match$6[0];
      const match$7 = React.useState(function () {
            return false;
          });
      const setFiltersChanged = match$7[1];
      const handleCheckboxChange = function ($$event) {
        if ($$event.target.checked) {
          const values = $$event.target.value === "pending" ? ({
                hd: "pending",
                tl: {
                  hd: "sent",
                  tl: /* [] */0
                }
              }) : ({
                hd: $$event.target.value,
                tl: /* [] */0
              });
          Curry._1(setSelectedState, (function (state) {
                  return Stdlib.$at(values, state);
                }));
          Curry._1(setFilterCount, (function (param) {
                  return filterCount + 1 | 0;
                }));
        } else {
          Curry._1(setFilterCount, (function (param) {
                  return filterCount - 1 | 0;
                }));
          Curry._1(setSelectedState, (function (state) {
                  return Stdlib__List.filter((function (el) {
                                return el !== $$event.target.value;
                              }), state);
                }));
        }
        Curry._1(setFiltersChanged, (function (param) {
                return true;
              }));
      };
      const handleRadioChange = function ($$event) {
        if ($$event.target.checked) {
          Curry._1(setSelectedOption, (function (param) {
                  return $$event.target.value;
                }));
          Curry._1(setPeriodCount, (function (param) {
                  return 1;
                }));
        } else {
          Curry._1(setSelectedOption, (function (param) {
                  return "";
                }));
          Curry._1(setPeriodCount, (function (param) {
                  return 0;
                }));
        }
        Curry._1(setSelectedOption, $$event.target.value);
        Curry._1(setFiltersChanged, (function (param) {
                return true;
              }));
      };
      const activatorRef = React.useRef(null);
      const dropdownRef = React.useRef(null);
      Buhta_cabinet__EventHandlers.useClickOutside(dropdownRef, activatorRef, (function (param) {
              Curry._1(setIsDropdownShown, (function (param) {
                      return false;
                    }));
            }));
      const handleDiscardFilters = function (param) {
        Curry._1(setSelectedOption, (function (param) {
                return "";
              }));
        Curry._1(setSelectedState, (function (param) {
                return /* [] */0;
              }));
        Curry._1(setPeriodCount, (function (param) {
                return 0;
              }));
        Curry._1(setFilterCount, (function (param) {
                return 0;
              }));
        Curry._1(setFiltersChanged, (function (param) {
                return true;
              }));
      };
      return JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("button", {
                          ref: activatorRef,
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        children: "Фильтр"
                                      }),
                                  (periodCount + filterCount | 0) > 0 ? JsxRuntime.jsxs(React.Fragment, {
                                          children: [
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                        className: "text-white",
                                                        children: String(filterCount + periodCount | 0)
                                                      }),
                                                  className: "ml-1 bg-primary w-5 h-5 rounded-full shrink-0 flex items-center justify-center"
                                                }),
                                            JsxRuntime.jsx("img", {
                                                  alt: "arrows",
                                                  src: StaticAsset.src("/static/icons/arrows-blue.svg")
                                                })
                                          ]
                                        }) : (
                                      isDropdownShown ? JsxRuntime.jsx("img", {
                                              alt: "arrows",
                                              src: StaticAsset.src("/static/icons/arrows-blue.svg")
                                            }) : JsxRuntime.jsx("img", {
                                              alt: "arrows",
                                              src: StaticAsset.src("/static/icons/select-arrows.svg")
                                            })
                                    )
                                ],
                                className: Cn.fromList({
                                      hd: "flex items-center cursor-pointer justify-end",
                                      tl: {
                                        hd: (periodCount + filterCount | 0) === 0 ? "gap-0" : "gap-1",
                                        tl: /* [] */0
                                      }
                                    })
                              }),
                          className: "h-full w-full",
                          onClick: (function (param) {
                              Curry._1(setIsDropdownShown, (function (param) {
                                      return !isDropdownShown;
                                    }));
                            })
                        }),
                    isDropdownShown ? JsxRuntime.jsx("div", {
                            ref: dropdownRef,
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                  className: "text-gray-medium",
                                                  children: "Фильтры"
                                                }),
                                            filterCount > 0 || periodCount > 0 ? JsxRuntime.jsx("a", {
                                                    children: JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                                          className: "flex gap-1 text-gray-medium cursor-pointer",
                                                          children: [
                                                            "Сбросить все",
                                                            JsxRuntime.jsx("img", {
                                                                  src: StaticAsset.src("/static/icons/refresh-reverse.svg")
                                                                })
                                                          ]
                                                        }),
                                                    onClick: handleDiscardFilters
                                                  }) : null
                                          ],
                                          className: "flex justify-between px-4 py-3 border-gray-main border-b"
                                        }),
                                    JsxRuntime.jsxs("a", {
                                          children: [
                                            JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                  className: "flex gap-3 text-black",
                                                  children: [
                                                    JsxRuntime.jsx("img", {
                                                          src: StaticAsset.src("/static/icons/date.svg")
                                                        }),
                                                    "Период"
                                                  ]
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    periodCount > 0 ? JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                                            size: "s",
                                                            kind: "primary",
                                                            className: "flex text-white !py-0.5 !px-1.5 rounded-xl items-center gap-1",
                                                            onClick: (function (ev) {
                                                                ev.stopPropagation();
                                                                Curry._1(setPeriodCount, (function (param) {
                                                                        return 0;
                                                                      }));
                                                                Curry._1(setSelectedOption, (function (param) {
                                                                        return "";
                                                                      }));
                                                                Curry._1(setFiltersChanged, (function (param) {
                                                                        return true;
                                                                      }));
                                                              }),
                                                            children: [
                                                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                    children: periodCount
                                                                  }),
                                                              JsxRuntime.jsx("img", {
                                                                    className: "w-3 h-3",
                                                                    alt: "close-circle-white",
                                                                    src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                                  })
                                                            ]
                                                          }) : null,
                                                    periodFilter ? JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "arrow-down-black",
                                                            src: StaticAsset.src("/static/icons/arrow-down-black.svg")
                                                          }) : JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "arrow-right",
                                                            src: StaticAsset.src("/static/icons/arrow-right.svg")
                                                          })
                                                  ],
                                                  className: "flex gap-3 items-center"
                                                })
                                          ],
                                          className: "flex justify-between items-center px-4 py-2.5",
                                          onClick: (function (param) {
                                              Curry._1(setPeriodFilter, (function (param) {
                                                      return !periodFilter;
                                                    }));
                                            })
                                        }),
                                    periodFilter ? JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-radio bg-gray-pale border focus:ring-0",
                                                            checked: selectedOption === "week",
                                                            type: "radio",
                                                            value: "week",
                                                            onChange: handleRadioChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Неделя",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex items-center gap-3 cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-radio bg-gray-pale border focus:ring-0",
                                                            checked: selectedOption === "month",
                                                            type: "radio",
                                                            value: "month",
                                                            onChange: handleRadioChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Месяц",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex items-center gap-3 cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-radio bg-gray-pale border focus:ring-0",
                                                            checked: selectedOption === "quarter",
                                                            type: "radio",
                                                            value: "quarter",
                                                            onChange: handleRadioChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "3 месяца",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex items-center gap-3 cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-radio bg-gray-pale border focus:ring-0",
                                                            checked: selectedOption === "half-year",
                                                            type: "radio",
                                                            value: "half-year",
                                                            onChange: handleRadioChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Полгода",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex items-center gap-3 cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-radio bg-gray-pale border focus:ring-0",
                                                            checked: selectedOption === "year",
                                                            type: "radio",
                                                            value: "year",
                                                            onChange: handleRadioChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Год",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex items-center gap-3 cursor-pointer"
                                                  })
                                            ],
                                            className: "py-2.5 bg-gray-pale"
                                          }) : null,
                                    JsxRuntime.jsxs("a", {
                                          children: [
                                            JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                  className: "flex gap-3 text-black",
                                                  children: [
                                                    JsxRuntime.jsx("img", {
                                                          alt: "loading",
                                                          src: StaticAsset.src("/static/icons/loading.svg")
                                                        }),
                                                    "Статус"
                                                  ]
                                                }),
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    filterCount > 0 ? JsxRuntime.jsxs(Buhta_cabinet__Button.make, {
                                                            size: "s",
                                                            kind: "primary",
                                                            className: "flex text-white !py-0.5 !px-1.5 rounded-xl items-center gap-1",
                                                            onClick: (function (ev) {
                                                                ev.stopPropagation();
                                                                Curry._1(setFilterCount, (function (param) {
                                                                        return 0;
                                                                      }));
                                                                Curry._1(setSelectedState, (function (param) {
                                                                        return /* [] */0;
                                                                      }));
                                                                Curry._1(setFiltersChanged, (function (param) {
                                                                        return true;
                                                                      }));
                                                              }),
                                                            children: [
                                                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                                    children: filterCount
                                                                  }),
                                                              JsxRuntime.jsx("img", {
                                                                    className: "w-3 h-3",
                                                                    alt: "close-circle-white",
                                                                    src: StaticAsset.src("/static/icons/close-circle-white.svg")
                                                                  })
                                                            ]
                                                          }) : null,
                                                    statusFilter ? JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "arrow-down-black",
                                                            src: StaticAsset.src("/static/icons/arrow-down-black.svg")
                                                          }) : JsxRuntime.jsx("img", {
                                                            className: "w-5 h-5",
                                                            alt: "arrow-right",
                                                            src: StaticAsset.src("/static/icons/arrow-right.svg")
                                                          })
                                                  ],
                                                  className: "flex gap-3 items-center"
                                                })
                                          ],
                                          className: "flex justify-between items-center relative px-4 py-2.5",
                                          onClick: (function (param) {
                                              Curry._1(setStatusFilter, (function (param) {
                                                      return !statusFilter;
                                                    }));
                                            })
                                        }),
                                    statusFilter ? JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-checkbox bg-gray-pale rounded border focus:ring-0",
                                                            checked: Stdlib__List.exists((function (el) {
                                                                    return el === "processed";
                                                                  }), selectedState),
                                                            type: "checkbox",
                                                            value: "processed",
                                                            onChange: handleCheckboxChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Успешно",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex gap-3 items-center cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-checkbox bg-gray-pale rounded border focus:ring-0",
                                                            checked: Stdlib__List.exists((function (el) {
                                                                    return el === "pending";
                                                                  }), selectedState),
                                                            type: "checkbox",
                                                            value: "pending",
                                                            onChange: handleCheckboxChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "В процессе",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex gap-3 items-center cursor-pointer"
                                                  }),
                                              JsxRuntime.jsxs("label", {
                                                    children: [
                                                      JsxRuntime.jsx("input", {
                                                            className: "form-checkbox bg-gray-pale rounded border focus:ring-0",
                                                            checked: Stdlib__List.exists((function (el) {
                                                                    return el === "failed";
                                                                  }), selectedState),
                                                            type: "checkbox",
                                                            value: "failed",
                                                            onChange: handleCheckboxChange
                                                          }),
                                                      JsxRuntime.jsx("span", {
                                                            children: "Ошибка",
                                                            className: "text-sm font-normal"
                                                          })
                                                    ],
                                                    className: "pl-12 flex gap-3 items-center cursor-pointer"
                                                  })
                                            ],
                                            className: "py-2.5 bg-gray-pale"
                                          }) : null,
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                                size: "s",
                                                kind: "primary",
                                                className: "text-white",
                                                disabled: !match$7[0],
                                                onClick: (function (param) {
                                                    Curry._1(sendDataToFilter, selectedState);
                                                    Curry._1(sendPeriodToFilter, selectedOption);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                    Curry._1(setFiltersChanged, (function (param) {
                                                            return false;
                                                          }));
                                                  }),
                                                children: "Сохранить"
                                              }),
                                          className: "border-t border-gray-main flex justify-end py-2 px-4"
                                        })
                                  ],
                                  className: "py-1"
                                }),
                            className: Cn.$plus("absolute right-0 z-10 w-80 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none", className)
                          }) : null
                  ],
                  className: "relative inline-block text-left pr-4 lg:pr-6 h-full"
                });
    };
  };
}

function Filter(Props) {
  return Curry._1(make(Props.sendDataToFilter)(Props.sendPeriodToFilter), Props.className);
}

const make$1 = Filter;

export {
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
